module.exports = __webpack_public_path__ + "img/empty.ff777923.png";